export enum BooleanEnum {
    Y = "Yes",
    N = "No",
}